module.exports = __webpack_public_path__ + "img/lpfv-pc-4000.f79d13f1.png";